import { CaretRight, Prohibit } from '@phosphor-icons/react';
import OnlineAvatar from '../../../../../../../shared/components/OnlineAvatar';
import { formatDate } from '../../../../../../../shared/utils/date';

type UserRowProps = {
  user: any;
  now: number;
  t: any;
  onSelect: () => void;
};

export default function UserRow({ user, now, t, onSelect }: UserRowProps) {
  return (
    <button className={user.banned ? 'banned' : ''} onClick={onSelect}>
      <OnlineAvatar user={user} now={now} />
      <span>
        <b>{user.firstName} {user.lastName}</b>
        <small>@{user.username} · {user.email}</small>
      </span>
      <span className="last-login">
        <small>{t.lastLogin}</small>
        {formatDate(user.lastLogin, t.locale)}
      </span>
      {user.banned && <em><Prohibit />{t.banned}</em>}
      <CaretRight />
    </button>
  );
}
